import { render, staticRenderFns } from "./FinancialAccounts.vue?vue&type=template&id=612e7628&scoped=true"
import script from "./FinancialAccounts.vue?vue&type=script&lang=js"
export * from "./FinancialAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e7628",
  null
  
)

export default component.exports